// extracted by mini-css-extract-plugin
export var activityContainer = "_jq-0";
export var typingIndicatorContainer = "_jq-1";
export var typingIndicatorDot = "_jq-2";
export var wave = "_jq-3";